import { Box, Button, CircularProgress, Grid } from "@material-ui/core"
import { CircularLoading } from "../../../../components"
import { useDefaultCadastroStyles } from "../../cadastros/components/default-cadastro-styles"
import { useStyles } from "./motoboy-styles"
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useState } from "react"
import { useKdsToken, useSessaoAtual, useToastSaurus } from "../../../../../services/app"
import { BarcodeScanIcon } from "../../../../components/icons/barcode-scan-icon"
import { useHistory } from "react-router-dom"
import { MotoboyData } from "./motoboy-data"
import { PedidoModel } from "../../../../../model/api/pedidos/pedido-model"
import { useGetPedido } from "../../../../../data/api/gestao/pedido/get-pedido"
import { EnumTipoPedido } from "../../../../../model/enums/enum-tipo-pedido"
import { EnumStatusPedidoLocal } from "../../../../../model/enums/enum-status-pedido-local"
import { useGetLocalizacaoUsuario } from "../../../../../data/api/localizacao/get-localizacao-usuario"
import { useRotasOtimizadasStore } from "../../../../../services/app/stores/rotas-otimizadas"
import { MapsIcon } from "../../../../components/icons/maps-icon"
import { usePostOtimizarRota } from "../../../../../data/api/gestao/rota/post-otimizar-rota"
import { OtimizarRotaResponseModel } from "../../../../../model/api/rota/otimizar-rota-response-model"

export interface MotoboyRef {
    tracarRotas: () => void
}

export interface MotoboyListProps {
    setCarregandoLocalizacao: React.Dispatch<React.SetStateAction<boolean>>
}

export const MotoboyList = forwardRef<MotoboyRef, MotoboyListProps>(({ setCarregandoLocalizacao }, ref) => {

    //AUX
    const history = useHistory();
    const classes = useStyles();
    const { showToast } = useToastSaurus();
    const listClasses = useDefaultCadastroStyles();
    const { getEmpresaSelecionada, usuario } = useSessaoAtual();
    const { getPessoaUsuario } = useKdsToken()
    const setPontosRotasPedidos = useRotasOtimizadasStore((state) => state.setPontosRotasPedidos)
    const { postOtimizarRota, carregando: carregandoOtimizarRota } = usePostOtimizarRota()

    const { obterLocalizacao } = useGetLocalizacaoUsuario()

    //STATES
    const [pedidos, setPedidos] = useState<PedidoModel[]>([]);
    const [carregandoRota, setCarregandoRota] = useState<boolean>(false);

    //CHAMADAS DA API
    const { getPedido, carregando: carregandoPedidos } = useGetPedido()

    // CARREGANDO
    const carregando = carregandoPedidos || carregandoOtimizarRota;


    // GET PRODUTO PROCESSO SETOR 
    const search = useCallback(
        async () => {
            try {
                let query = `?tipoPedido=${EnumTipoPedido.ENTREGA}&status=${EnumStatusPedidoLocal.ENVIADO}&entregadorId=${getPessoaUsuario()?.pessoa.id}`
                const res = await getPedido(getEmpresaSelecionada()?.Id!, query);

                if (res.erro) throw res.erro;
                if (!res.resultado) return;

                const resultado = res.resultado.data.list as PedidoModel[]
                setPedidos(resultado);
            } catch (e: any) {
                showToast('error', e.message);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [usuario?.usuarioId, getEmpresaSelecionada, showToast],
    );

    const handleClickButtonFab = useCallback(() => {
        history.push('/adicionar-pedido?modulo=motoboy');
    }, [history])

    const handleClickButtonTracarRotas = useCallback(async () => {
        showToast('info', 'Iniciando rastreamento de rotas...')
        setCarregandoLocalizacao(true)
        try {
            showToast('info', 'Verificando pedidos...')
            if (pedidos.length === 0) {
                throw new Error('Nenhum pedido para rastrear');
            }
            showToast('info', 'Obtendo localização...')
            const minhaLocalizacao = await obterLocalizacao()
            showToast('info', 'Calculando rota...')
            const res = await postOtimizarRota({
                origem: {
                    coordenadas: {
                        latitude: minhaLocalizacao.latitude!,
                        longitude: minhaLocalizacao.longitude!,
                    }
                },
                destino: {
                    coordenadas: {
                        latitude: minhaLocalizacao.latitude!,
                        longitude: minhaLocalizacao.longitude!,
                    }
                },
                pontosDeEntrega: pedidos.map(pedido => ({
                    endereco: {
                        logradouro: pedido.enderecoEntrega?.logradouro || '',
                        bairro: pedido.enderecoEntrega?.bairro || '',
                        estado: pedido.enderecoEntrega?.uf || '',
                        pais: pedido.enderecoEntrega?.pais || '',
                        numero: pedido.enderecoEntrega?.numero || '',
                        cidade: pedido.enderecoEntrega?.municipio || '',
                        cep: pedido.enderecoEntrega?.cep || '',
                        codigoMunicipio: pedido.enderecoEntrega?.codigoMunicipio || '',
                        codigoUF: '',
                    }
                }))
            })

            showToast('success', 'Rota calculada com sucesso!')

            const resultadoRota = res.resultado?.data as OtimizarRotaResponseModel

            const pedidosOrganizados: string[] = []
            resultadoRota.rota?.forEach(point => {
                const getPedido = pedidos[point.ordem]
                if (getPedido) {
                    pedidosOrganizados.push(getPedido.id)
                }
            })
            setPontosRotasPedidos(pedidosOrganizados)

            showToast('success', 'Rotas otimizadas para entrega!')
        } catch (e: any) {
            showToast('error', e.message);
        }
        finally {
            setCarregandoLocalizacao(false)
        }
    }, [setCarregandoLocalizacao, pedidos, obterLocalizacao, postOtimizarRota, setPontosRotasPedidos, showToast])

    useEffect(() => {
        search();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useImperativeHandle(ref, () => ({
        tracarRotas: handleClickButtonTracarRotas,
    }))

    const pontosRotasPedidos = useRotasOtimizadasStore((state) => state.pontosRotasPedidos)

    const listaPedidosOrganizada = useMemo(() => {
        if (!pontosRotasPedidos || pontosRotasPedidos.length === 0) {
            return pedidos;
        }

        return [...pedidos].sort((a, b) => {
            const indexA = pontosRotasPedidos.indexOf(a.id);
            const indexB = pontosRotasPedidos.indexOf(b.id);

            // Se ambos estão na lista, ordena pelo índice
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            }

            // Se a está na lista mas b não, a vem primeiro
            if (indexA !== -1) {
                return -1;
            }

            // Se b está na lista mas a não, b vem primeiro
            if (indexB !== -1) {
                return 1;
            }

            // Se nenhum dos dois está na lista, mantém a ordem original
            return 0;
        });
    }, [pedidos, pontosRotasPedidos]);

    const handleRotaEntrega = useCallback(async () => {
        try {
            showToast('info', 'Calculando rota...')
            setCarregandoRota(true)
            const minhaLocalizacao = await obterLocalizacao()
            const enderecos = listaPedidosOrganizada.map(pedido => `${pedido.enderecoEntrega?.logradouro}, ${pedido.enderecoEntrega?.numero}, ${pedido.enderecoEntrega?.bairro}, ${pedido.enderecoEntrega?.municipio}, ${pedido.enderecoEntrega?.uf}`)
            const origin = `origin=${minhaLocalizacao.latitude},${minhaLocalizacao.longitude}`
            const waypoints = `waypoints=${enderecos.slice(0, -1).join('|')}`
            const destination = `destination=${enderecos[enderecos.length - 1]}`
            const link = `https://www.google.com/maps/dir/?api=1&${origin}&${destination}&${waypoints}&travelmode=motorcycle`
            window.open(link, '_blank')
            showToast('success', 'Rota calculada com sucesso!')
        } catch (err: any) {
            showToast('error', err.message);
        } finally {
            setCarregandoRota(false)
        }
    }, [listaPedidosOrganizada, obterLocalizacao, showToast])

    return (
        <>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Grid className={classes.list}>
                <div className={classes.defaultContainer}>
                    <Grid className={listClasses.list}>
                        <Grid item xs={12} container className={classes.listContainer}>
                            <MotoboyData
                                carregando={carregando}
                                list={listaPedidosOrganizada}
                                handleReloadPedidos={search}
                            />
                        </Grid>
                    </Grid>
                </div>
            </Grid>
            <Box p={2} position="fixed" bgcolor="#ffffff" bottom={0} right={0} borderRadius={8} boxShadow={3} width="100%">
                <Grid container spacing={2}>
                    <Grid item xs={true}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={handleRotaEntrega}
                            disabled={carregandoRota || listaPedidosOrganizada.length === 0}
                        >
                            {carregandoRota ? <CircularProgress color="inherit" size={24} /> : <MapsIcon tipo="BUTTON_PRIMARY" />}
                            Rota de Entrega
                        </Button>
                    </Grid>
                    <Grid item xs={'auto'}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => { handleClickButtonFab() }}
                        >
                            <BarcodeScanIcon tipo="BUTTON_PRIMARY" style={{ marginRight: 0 }} />
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
})